
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-a-quote/thank-you",
      function () {
        return require("private-next-pages/get-a-quote/thank-you.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-a-quote/thank-you"])
      });
    }
  